import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { BlindData } from '@root/app.interfaces';
import { CONFIG } from '@root/app.config';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

type CarouselType = 'single' | 'multiple';
type TemplateRefGeneric = { index: number; $implicit: BlindData };
type SlideConfigs = { [K in CarouselType]: SlickCarouselComponent['config'] };

@Component({
	selector: 'app-gallery-carousel',
	templateUrl: './gallery-carousel.component.html',
	styleUrls: ['./gallery-carousel.component.scss', './gallery-carousel.responsive.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class GalleryCarouselComponent {
	@Input() blindsData: BlindData[];
	@Input() carouselType: CarouselType;
	@Input() slideTemplate: TemplateRef<TemplateRefGeneric>;

	// Slide config for Shop Variant
	protected readonly SLIDE_CONFIG_SINGLE = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		infinite: false,
		variableWidth: false,
		mobileFirst: true,
	};

	protected readonly SLIDE_CONFIG = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		infinite: false,
		variableWidth: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: CONFIG.breakpoints['tablet-landscape'],
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};

	protected readonly SLIDE_CONFIGS: SlideConfigs = {
		single: this.SLIDE_CONFIG_SINGLE,
		multiple: this.SLIDE_CONFIG,
	};

	trackByIndex(index: number): number {
		return index;
	}
}
